import HttpReq from "../../service/httpReq"
import ReportUtils from "../reportUtils";
import Cache from "./cache"

function cacheKey(schemaId, includeProvenance) {
    return "ManagedReportsRepo" + schemaId + ":" + includeProvenance
}

//TODO Rename ManagedReportsRepo
class ReportsRepo {
    static publicPath = 'api/managed-reports'
    static mgmtPath = 'api/mgmt/managed-reports'

    /**
     * @param {number} schemaId Required
     * @param {Function} reportConsumer Required
     * @param {Function} [errorConsumer] Optional
     * @param {boolean} [includeProvenance] Optional Asks the backend to ground every value in its
     * source document. Off by default: only Source view needs it and it is a large payload. The two
     * variants are cached separately, so switching it on does cost a request.
     */
    static listBySchema(schemaId, reportConsumer, errorConsumer, includeProvenance = false) {
        const params = new URLSearchParams({
            schemaId: String(schemaId),
            includeProvenance: String(includeProvenance)
        })
        Cache.get(cacheKey(schemaId, includeProvenance), func => {
            HttpReq.get(ReportsRepo.publicPath + "?" + params, func, errorConsumer)
        }, reportConsumer)
    }

    static save(createReportSpec, reportConsumer, errorConsumer) {
        ReportUtils.hasMissingMetadata(createReportSpec, "ReportsRepo.save")
        ReportUtils.hasOrphanedMetadata(createReportSpec, "ReportsRepo.save")
        Cache.clear()
        HttpReq.post(ReportsRepo.mgmtPath, createReportSpec, reportConsumer, errorConsumer)
    }

    static update(updateReportSpec, reportConsumer, errorConsumer) {
        ReportUtils.hasMissingMetadata(updateReportSpec, "ReportsRepo.update")
        ReportUtils.hasOrphanedMetadata(updateReportSpec, "ReportsRepo.update")
        Cache.clear()
        HttpReq.put(ReportsRepo.mgmtPath, updateReportSpec, reportConsumer, errorConsumer)
    }

    static delete(id, resConsumer, errorConsumer) {
        Cache.clear()
        HttpReq.delete(ReportsRepo.mgmtPath + "/" + id, resConsumer, errorConsumer)
    }

    static invalidateCache() {
        Cache.clear()
    }
}

export default ReportsRepo